import { createI18n } from 'vue-i18n';
import enEN from './locales/en-EN.js';
import nlNL from './locales/nl-NL.js';

// Before login there is no organization language yet, so fall back to the browser languages
const browserLanguages = navigator.languages?.length ? navigator.languages : [navigator.language];
const browserLocale = browserLanguages.some((lang) => lang?.toLowerCase().startsWith('nl'))
  ? 'nl-NL'
  : 'en-EN';

// Create i18n instance
export const i18n = createI18n({
  legacy: false, // Use Composition API mode
  locale: browserLocale,
  fallbackLocale: 'en-EN',
  messages: {
    'en-EN': enEN,
    'nl-NL': nlNL,
  },
});

// Helper function to map organization language to i18n locale
export function mapOrganizationLanguageToLocale(orgLanguage) {
  const languageMap = {
    'en-US': 'en-EN',
    'en-EN': 'en-EN',
    'nl-NL': 'nl-NL',
    'nl-BE': 'nl-NL', // Belgian Dutch maps to Dutch
  };

  return languageMap[orgLanguage] || 'en-EN';
}

// Helper function to set locale based on organization
export function setLocaleFromOrganization(organization) {
  if (organization?.language) {
    const locale = mapOrganizationLanguageToLocale(organization.language);
    i18n.global.locale.value = locale;
    return locale;
  }
  return 'en-EN';
}

export default i18n;
